import { fetchStocks } from "./inventoryAction";

export function createReapproExt(newReapproExt, page = "sales"){
    console.log("FIRED ACTION CREATE REAPPRO_EXT", newReapproExt)
    return async function(dispatch){
        dispatch({
            type: "CREATE_REAPPRO_EXT_START",
            payload: ""
        })

        try {
            const response = await fetch('/stocks/reappro/ext/new',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({data: newReapproExt}),
                credentials: 'same-origin',
            }); 
            
            const createdReapproExt = await response.json()
            console.log({createdReapproExt})// createdReapproExt returns new object created

            // ✅ Si on reçoit bien un objet créé (id présent), on l'ajoute au store Redux
            if (createdReapproExt && createdReapproExt.id){ 

                dispatch({
                    type:"NEW_REAPPRO_EXT",
                    payload: createdReapproExt, // on envoie l'objet complet, pas seulement l'id
                })
                dispatch({ type: "CREATE_REAPPRO_EXT_FULFILLED", payload:"" })
                
                dispatch(fetchStocks())
                return createdReapproExt;
            } else {
                const errorMessage = createdReapproExt?.error?.message || "Erreur lors de la création du réappro externe";
                dispatch({
                    type: "CREATE_REAPPRO_EXT_ERROR",
                    payload: errorMessage,
                })
                throw new Error(errorMessage); 
            }
            
        } catch (err) {
            console.log('====================================');
            console.log("error create sale", err);
            console.log('====================================');
            dispatch({
                type: "CREATE_REAPPRO_EXT_ERROR",
                payload: err
            })
            throw err;
        }
    }
}
